import { CommonModule } from "@angular/common";
import { Component, forwardRef, HostBinding, Injector, Input, ViewEncapsulation } from "@angular/core";
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgControl, ValidationErrors } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MaterialFormModule } from "src/app/_shared/material/material-form.module";
import {
  fieldSimplified,
  optionsGroup,
} from "../../_interfaces/formDataSimplified";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckbox, MatCheckboxChange } from "@angular/material/checkbox";
export function groupedMultiselectValidator(control: AbstractControl): ValidationErrors | null {
  // Add your validation logic here
  if (!control.value || control.value.length === 0) {
    return { required: true };
  }
  return null;
}
@Component({
  selector: "app-grouped-multiselect",
  templateUrl: "./grouped-multiselect.component.html",
  styleUrls: ["./grouped-multiselect.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MaterialFormModule,
    MatAutocompleteModule,
    MatIconModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GroupedMultiselectComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => GroupedMultiselectComponent),
      multi: true,
    }
  ],
})
export class GroupedMultiselectComponent implements ControlValueAccessor {
  @Input() field: fieldSimplified;
  private cloneOptionGroups: optionsGroup[];
  private isCloned: boolean = false;
  cloneField: any;

  private onChange = (value: any) => {};
  private onTouched = () => {};
  public ngControl: NgControl | null = null;

  constructor(private injector: Injector) {}
  @HostBinding('class.ng-invalid') 
  get isInvalid(): boolean {
    return this.ngControl ? (this.ngControl.invalid && (this.ngControl.touched || this.ngControl.dirty)) : false;
  }

  @HostBinding('class.ng-valid') 
  get isValid(): boolean {
    return this.ngControl ? (this.ngControl.valid && (this.ngControl.touched || this.ngControl.dirty)) : false;
  }

  @HostBinding('class.ng-touched') 
  get isTouched(): boolean {
    return this.ngControl ? this.ngControl.touched : false;
  }

  @HostBinding('class.ng-dirty') 
  get isDirty(): boolean {
    return this.ngControl ? this.ngControl.dirty : false;
  }
  ngOnInit() {
      try {
      this.ngControl = this.injector.get(NgControl, null);
      if (this.ngControl) {
        this.ngControl.valueAccessor = this;
      }
    } catch (error) {
      // Handle case where NgControl is not available
      console.warn('NgControl not available for GroupedMultiselectComponent');
    }
  }

  get shouldShowError(): boolean {
    return this.ngControl ? (this.ngControl.invalid && (this.ngControl.touched || this.ngControl.dirty)) : false;
  }
   validate(control: AbstractControl): ValidationErrors | null {
    if (this.field?.required && (!control.value || control.value.length === 0)) {
      return { required: true };
    }
    return null;
  }
  ngOnChanges() {
    this.addSelectAllOption();
  }

  addSelectAllOption() {
    let optionGroup: optionsGroup = {
      title: "Select All",
      fields: [
        {
          key: "",
          value: "",
          disabled: false,
        },
      ],
    };
    this.field?.optionGroups?.unshift(optionGroup);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  onInputChange(event: Event, field: fieldSimplified): void {
    const target = event.target as HTMLInputElement;
    let searchVal = target.value.toLowerCase();
    console.log(searchVal)

    if (!searchVal) {
      field.optionGroups = this.cloneOptionGroups;
      return;
    }
    field.optionGroups = field.optionGroups
      .map((group: optionsGroup) => {
        const titleMatches = group?.title?.toLowerCase().includes(searchVal);
        const filteredFields = group?.fields?.filter((opt: any) =>
          opt?.key?.toLowerCase().includes(searchVal)
        );
        if (titleMatches) {
          return group;
        }

        if (filteredFields?.length > 0) {
          return {
            ...group,
            fields: filteredFields,
          };
        }
      })
      .filter((group: any) => group !== null);
  }
  isSelected(data: any): boolean {
    if (data.value === "SELECT_ALL") {
      const totalFields = this.field.optionGroups
        .filter((g) => g.title !== "Select All")
        .reduce((sum, g) => sum + g.fields.length, 0);
      return this.field.value.length === totalFields;
    }
    return (this.field.value || []).some(
      (item: any) => item.value === data.value
    );
  }

  onGroupHeaderClick(event: MouseEvent, group: optionsGroup, checkbox: MatCheckbox): void {
    event.preventDefault();
    event.stopPropagation();
    checkbox.toggle();
    const mockEvent = {
      checked: checkbox.checked,
      source: checkbox
    } as MatCheckboxChange;
    this.selectCity(mockEvent, group);
  }
    
  selectCity($event: any, group: any) {
    let newSelected = [...(this.field.value || [])];
    if (group.title === "Select All") {
      if ($event.checked) {
        this.field.optionGroups.forEach((optGroup: any) => {
          if (optGroup.title !== "Select All") {
            optGroup.fields.forEach((item: any) => {
              if (!newSelected.some((v: any) => v.value === item.value)) {
                newSelected.push(item);
              }
            });
          }
        });
      } else {
        newSelected = [];
      }
    } else {
      if ($event.checked) {
        group.fields.forEach((item: any) => {
          if (!newSelected.some((v: any) => v.value === item.value)) {
            newSelected.push(item);
          }
        });
      } else {
        console.log(newSelected);
        newSelected = newSelected.filter(
          (v: any) => !group.fields.some((g: any) => g.value === v.value)
        );
      }
    }

    this.field.value = newSelected;
    this.onChange(this.field.value);
    this.onTouched();
  }
  get hasMoreThanThree(): boolean {
    return (this.field.value || []).length > 2;
  }

  displayFn(data1: any): string {
    console.log(data1);
    return "";
  }

  trackByValue(index: number, item: any): any {
    return index;
  }

  writeValue(value: any): void {
    if (value) {
      this.field.value = value;
    }
  }
  get selectedKeysString(): string {
    const keys = (this.field.value || []).map((item: any) => item.value.hotel);
    return (
      keys.slice(0, 3).join(", ") +
      (keys.length > 3 ? ` +${keys.length - 3}` : "")
    );
  }

  get extraSelectedCount(): number {
    return (this.field.value?.length || 0) - 2;
  }
  toggleSelection(item: any) {
    let newSelected = [...(this.field.value || [])];
    // Handle Select All
    if (item.value === "SELECT_ALL") {
      if (!this.isSelected(item)) {
        // Select all items from all groups except "Select All"
        this.field.optionGroups.forEach((optGroup) => {
          if (optGroup.title !== "Select All") {
            optGroup.fields.forEach((field) => {
              if (!newSelected.some((v) => v.value === field.value)) {
                newSelected.push(field);
              }
            });
          }
        });
      } else {
        // Deselect all
        newSelected = [];
      }
    } else {
      const index = newSelected.findIndex((v) => v.value === item.value);
      if (index >= 0) {
        newSelected.splice(index, 1);
      } else {
        newSelected.push(item);
      }
    }

    this.field.value = newSelected;
    this.onChange(this.field.value);
    this.onTouched();
  }
  focusAutoCompleteInput(optionGroups: optionsGroup[]) {
    console.log(optionGroups);
    if (!this.isCloned && optionGroups.length) {
      this.isCloned = true;
      this.cloneOptionGroups = optionGroups;
    }
  }
  isGroupSelected(group: optionsGroup): boolean {
    if (!this.field?.value?.length) return false;
    if (group.title === "Select All") {
      const totalFields = this.field.optionGroups
        .filter((g) => g.title !== "Select All")
        .reduce((sum, g) => sum + g.fields.length, 0);

      return this.field.value.length === totalFields;
    }
    return group?.fields?.every((field) =>
      this.field.value.some((v: any) => v.value === field.value)
    );
  }
  onEnterKey(event: any) {
  event.preventDefault(); // stops autocomplete from closing
  event.stopPropagation(); // prevents default selection behavior
  // Find the active option from the autocomplete panel
  const panel = document.querySelector('.mat-autocomplete-panel');
  const activeItem = panel?.querySelector('.mat-active');

  if (activeItem) {
    const checkbox = activeItem.querySelector('mat-checkbox input') as HTMLInputElement;
    if (checkbox) {
      checkbox.click(); // simulate toggle
    }
  }
}

}
